/* eslint-disable */
import {execute, grable} from '../concrete'

const concreteModuleName = 'concrete'

const FarmersMoneyNotAreaService = {
    /**
     * 编辑资金
     * @param {*} updateData 
     * @returns Promise 
     */
    'updateFarmersMoney': function (updateData) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '805eeb5372c53410f921db217353051a72946c1c', updateData)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyNotAreaService/farmersMoney`, 'json', 'PUT', updateData);
    }, 
    /**
     * 增加作业补贴
     * @param {*} addData 
     * @returns Promise 
     */
    'addFarmersMoneyWork': function (addData) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '06839c9be60881400a5a2ac85861ddd8d041313d', addData)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyNotAreaService/addFarmersMoneyWork`, 'json', 'POST', addData);
    }, 
    /**
     * 资金详情
     * @param {*} farmersMoneyId 
     * @returns Promise 
     */
    'detailFarmersMoney': function (farmersMoneyId) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '30830ec7701a5cdf3e7da88647fab0531e466eb1', farmersMoneyId)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyNotAreaService/detailFarmersMoney`, 'json', 'POST', { farmersMoneyId });
    }, 
    /**
     * 惠农资金列表概览
     * @param {*} year 
     * @returns Promise 
     */
    'farmersMoneyOverview': function (year) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '00620094d06386259c0c3f86766e9dc9be011c57', year)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyNotAreaService/farmersMoneyOverview`, 'json', 'POST', { year });
    }, 
    /**
     * 增加惠农总资金
     * @param {*} addData 
     * @returns Promise 
     */
    'addFarmersMoneyTotal': function (addData) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'd3529f927b89938fa9a4786f60396e6879773093', addData)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyNotAreaService/addFarmersMoneyTotal`, 'json', 'POST', addData);
    }, 
    /**
     * 增加购机补贴
     * @param {*} addData 
     * @returns Promise 
     */
    'addFarmersMoneyVehicle': function (addData) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'e3a95da41ec7b8e9eb9acfebeb12873a1abd0064', addData)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyNotAreaService/addFarmersMoneyVehicle`, 'json', 'POST', addData);
    }, 
    /**
     * 购机补贴详情
     * @param {*} year 
     * @returns Promise 
     */
    'detailVehicleDetail': function (year) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '7432028ed8490449ce2ac58157edc1ff0ed62073', year)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyNotAreaService/detailVehicleDetail`, 'json', 'POST', { year });
    }, 
    /**
     * 作业补贴详情
     * @param {*} year 
     * @returns Promise 
     */
    'detailWorkDetail': function (year) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'f321c57308ec7da8af7918a676001206c7517802', year)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyNotAreaService/detailWorkDetail`, 'json', 'POST', { year });
    }, 
    /**
     * 惠农总资金详情
     * @param {*} year 
     * @returns Promise 
     */
    'listFarmersMoneyTotal': function (year) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '31a9fa045197c3422293b4bbffb1f517c9296622', year)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyNotAreaService/listFarmersMoneyTotal`, 'json', 'POST', { year });
    }, 
    /**
     * 其它资金详情
     * @param {*} year 
     * @returns Promise 
     */
    'detailOtherDetail': function (year) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'de5e3c4fa082f9316025acc712470c98f2fcf20f', year)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyNotAreaService/detailOtherDetail`, 'json', 'POST', { year });
    }, 
    /**
     * 选择下级区域(地区，不是账号)
     * @returns Promise 
     */
    'listLowerArea': function () {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '6af87524f9e69612195fbc607c8e7e83168515b9')
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyNotAreaService/listLowerArea`, 'json', 'GET');
    }
}

export default FarmersMoneyNotAreaService
